import React from "react";
import PropTypes from "prop-types";

import TouchNewClient from "./TouchNewClient";
import moment from "moment";

const TouchItem = ({ touch }) => {
  const {
    appName,
    clientId,
    clientName,
    timestamp,
    ipAddress,
    hitCount
  } = touch;

  return (
    <div className="card-slim bg-light">
      <div className="grid-4">
        <div>
          <span
            style={{ fontSize: "10px", position: "relative", top: "-10px" }}
          >
            {moment(timestamp).format("MM/DD/YYYY HH:MM A")}
          </span>
          <br />
          <h4
            className="text-primary text-left"
            style={{ position: "relative", top: "-10px" }}
          >
            {appName}
          </h4>
        </div>
        <div className="mt-3">
          {clientId ? clientId : <span className="text-danger">NEW</span>}
          {" - "}
          {clientName}
        </div>
        <div className="mt-3">From: {ipAddress}</div>
        <div className="mt-3">
          <span className="right">
            {!clientId && <TouchNewClient touch={touch} />}
          </span>
          Hits: {hitCount}
          {"  "}
        </div>
      </div>
    </div>
  );
};

TouchItem.propTypes = {
  touch: PropTypes.object.isRequired
};

export default TouchItem;
